exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".techTree[data-v-4388d9a4]{background-color:#222;margin-top:10px;border-radius:5px;padding-top:1px;padding-bottom:20px}.techTree>h2[data-v-4388d9a4]{text-align:center;font-weight:bolder;margin-bottom:0}.techTree>h2 a[data-v-4388d9a4]{color:inherit;text-decoration:none}.techTree>h2 a[data-v-4388d9a4]:hover{text-decoration:underline}.techTree h3[data-v-4388d9a4]{text-align:center;font-weight:lighter;font-style:italic;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4388d9a4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TechTree.vue
// module id = 120
// module chunks = 0